import { Box, Typography } from '@mui/material';

import { lumiqMonoIconLogo } from '@/assets';
import { Button } from '@/components';

export interface DescriptionCardProps {
  title: string;
  hook: string;
  onClick: () => void;
}

export const DescriptionCard = ({
  title,
  hook,
  onClick,
}: DescriptionCardProps) => {
  return (
    <Box
      sx={{
        px: 6,
        py: 4,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: 290,
        textAlign: 'center',
        gap: 1.5,
      }}>
      <Box
        component="img"
        src={lumiqMonoIconLogo}
        alt="lumiq logo"
        sx={{ width: 48, height: 48 }}
      />
      <Typography variant="h1">{title}</Typography>
      <Typography variant="body3">{hook}</Typography>
      <Button
        label="View All"
        color="primary"
        fullWidth={false}
        onClick={onClick}
      />
    </Box>
  );
};
